var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { ThemeFamilies } from '../../theme/families';
import Tooltip from '../Tooltip';
export var IconName;
(function (IconName) {
    IconName["ACCEPT"] = "accept";
    IconName["ACTIVATE"] = "activate";
    IconName["ACTIVATE_CARD"] = "activate_card";
    IconName["ADD_CREDIT_CARD"] = "add_credit_card";
    IconName["ADD_IBAN"] = "add_iban";
    IconName["ADD_NOTIFICATION"] = "add_notification";
    IconName["ADD_PAYOUT"] = "add_payout";
    IconName["ADD_SQ"] = "add_sq";
    IconName["ADD_USER"] = "add_user";
    IconName["ADJUSMENTS"] = "adjusments";
    IconName["APP"] = "app";
    IconName["APPROVE_BALANCE"] = "approve_balance";
    IconName["ARCHIVE"] = "archive";
    IconName["ARROW_DOWN"] = "arrow_down";
    IconName["ARROW_LEFT"] = "arrow_left";
    IconName["ARROW_RIGHT"] = "arrow_right";
    IconName["ARROW_S_DOWN"] = "arrow_s_down";
    IconName["ARROW_S_LEFT"] = "arrow_s_left";
    IconName["ARROW_S_RIGHT"] = "arrow_s_right";
    IconName["ARROW_S_UP"] = "arrow_s_up";
    IconName["ARROW_UP"] = "arrow_up";
    IconName["ATTACH"] = "attach";
    IconName["AUDIT"] = "audit";
    IconName["AVAILABLE_BALANCE"] = "available_balance";
    IconName["BAG"] = "bag";
    IconName["BANK"] = "bank";
    IconName["BANK_REDIRECT"] = "bank_redirect";
    IconName["BARS"] = "bars";
    IconName["BITCOIN"] = "bitcoin";
    IconName["BLOCK"] = "block";
    IconName["BLOCK_1"] = "block-1";
    IconName["BOARD"] = "board";
    IconName["BOLD"] = "bold";
    IconName["BOOK"] = "book";
    IconName["BOOKMARK"] = "bookmark";
    IconName["BUILDING"] = "building";
    IconName["BULB"] = "bulb";
    IconName["BULK"] = "bulk";
    IconName["BURGER"] = "burger";
    IconName["BUSINESS"] = "business";
    IconName["CALCULATOR"] = "calculator";
    IconName["CALCULATOR_2"] = "calculator_2";
    IconName["CALENDAR"] = "calendar";
    IconName["CALENDAR_NOTIFICATION"] = "calnedar_notification";
    IconName["CAMERA"] = "camera";
    IconName["CARDS"] = "cards";
    IconName["CART"] = "cart";
    IconName["CASE"] = "case";
    IconName["CASH"] = "cash";
    IconName["CASH_IN"] = "cash_in";
    IconName["CASH_OUT"] = "cash_out";
    IconName["CERTIFICATION"] = "certification";
    IconName["CHANGE_DIRECTION"] = "change_direction";
    IconName["CHART"] = "chart";
    IconName["CHAT"] = "chat";
    IconName["CHECK"] = "check";
    IconName["CHECK_SQ"] = "check_sq";
    IconName["CHEVRON_C_DOWN"] = "chevron_c_down";
    IconName["CHEVRON_C_LEFT"] = "chevron_c_left";
    IconName["CHEVRON_C_RIGHT"] = "chevron_c_right";
    IconName["CHEVRON_C_UP"] = "chevron_c_up";
    IconName["CHEVRON_DOWN"] = "chevron_down";
    IconName["CHEVRON_LEFT"] = "chevron_left";
    IconName["CHEVRON_RIGHT"] = "chevron_right";
    IconName["CHEVRON_S_DOWN"] = "chevron_s_down";
    IconName["CHEVRON_S_LEFT"] = "chevron_s_left";
    IconName["CHEVRON_S_RIGHT"] = "chevron_s_right";
    IconName["CHEVRON_S_UP"] = "chevron_s_up";
    IconName["CHEVRON_UP"] = "chevron_up";
    IconName["CLOCK"] = "clock";
    IconName["CLOCK_SQ"] = "clock_sq";
    IconName["CLOSE_2"] = "close_2";
    IconName["COFFEE"] = "coffee";
    IconName["COIN"] = "coin";
    IconName["COLLECT"] = "collect";
    IconName["COLOR_PICKER"] = "color_picker";
    IconName["COMMAND"] = "command";
    IconName["COMMENT"] = "comment";
    IconName["COMPASS"] = "compass";
    IconName["COMPLETE_REFUND"] = "complete_refund";
    IconName["COMPLIANCE"] = "compliance";
    IconName["COPY"] = "copy";
    IconName["CPU"] = "cpu";
    IconName["CREDIT_CARD"] = "credit_card";
    IconName["CREDIT_ERROR"] = "credit_error";
    IconName["CROP"] = "crop";
    IconName["DEACTIVATE"] = "deactivate";
    IconName["DELETE"] = "delete";
    IconName["DELETE_SQ"] = "delete_sq";
    IconName["DEPLOMA"] = "deploma";
    IconName["DESKTOP"] = "desktop";
    IconName["DEVELOPERS"] = "developers";
    IconName["DISABLE"] = "disable";
    IconName["DISBURSE"] = "disburse";
    IconName["DISLIKE"] = "dislike";
    IconName["DISPUTE"] = "dispute";
    IconName["DOC"] = "doc";
    IconName["DOC_DELETE"] = "doc_delete";
    IconName["DOC_DOWNLOAD"] = "doc_download";
    IconName["DOC_MAIN"] = "doc_main";
    IconName["DOC_MINUS"] = "doc_minus";
    IconName["DOC_PLUS"] = "doc_plus";
    IconName["DOC_UPLOAD"] = "doc_upload";
    IconName["DOLLAR"] = "dollar";
    IconName["DOLLAR_TRANSFER"] = "dollar_transfer";
    IconName["DOUBLE_CHEVRON_LEFT"] = "double_chevron_left";
    IconName["DOUBLE_CHEVRON_RIGHT"] = "double_chevron_right";
    IconName["DOWNLOAD"] = "download";
    IconName["DOWNLOAD_TRANSACTIONS"] = "download_transactions";
    IconName["DRAG"] = "drag";
    IconName["EDIT"] = "edit";
    IconName["ENVELOP"] = "envelop";
    IconName["EQUAL"] = "equal";
    IconName["EURO"] = "euro";
    IconName["FAVORITE"] = "favorite";
    IconName["FILLED_DOWN_ARROW"] = "filled_down_arrow";
    IconName["FILLED_UP_ARROW"] = "filled_up_arrow";
    IconName["FILTER"] = "filter";
    IconName["FINGERPRINT"] = "fingerprint";
    IconName["FOCUS"] = "focus";
    IconName["FOLDER"] = "folder";
    IconName["FOLDER_1"] = "folder_1";
    IconName["GENDER"] = "gender";
    IconName["GETEWAY"] = "gateway";
    IconName["GRAPH"] = "graph";
    IconName["HARDRIVE"] = "hardrive";
    IconName["HASHTAG"] = "hashtag";
    IconName["HEART"] = "heart";
    IconName["HIDE"] = "hide";
    IconName["HOME"] = "home";
    IconName["ICON_360"] = "360";
    IconName["ID"] = "id";
    IconName["IMAGE"] = "image";
    IconName["INBOX"] = "inbox";
    IconName["INFO_2"] = "info_2";
    IconName["INFO_SQ"] = "Info_sq";
    IconName["KEYBOARD"] = "keyboard";
    IconName["LABEL"] = "label";
    IconName["LAYERS"] = "layers";
    IconName["LIKE"] = "like";
    IconName["LINK"] = "link";
    IconName["LINK2"] = "link_2";
    IconName["LOCATION"] = "location";
    IconName["LOCK"] = "lock";
    IconName["LOCK_FILLED"] = "lock_filled";
    IconName["LOGIN"] = "login";
    IconName["LOOP"] = "loop";
    IconName["MENU_BACK"] = "menu_back";
    IconName["MERCHANT"] = "merchant";
    IconName["MINUS"] = "minus";
    IconName["MINUS_SQ"] = "minus_sq";
    IconName["MOBILE"] = "mobile";
    IconName["MOON"] = "moon";
    IconName["MORE_CIRCULAR"] = "more_circular";
    IconName["MORE_HORIZONTAL"] = "more_horizontal";
    IconName["MORE_SQUARE"] = "more_sq";
    IconName["MORE_VERTICAL"] = "more_vertical";
    IconName["MULTI_CARDS"] = "multi_cards";
    IconName["NEST"] = "nest";
    IconName["NOTIFICATION_1"] = "notification_1";
    IconName["NOT_EQUAL"] = "not_equal";
    IconName["OPEN_LINK"] = "open_link";
    IconName["OPTIONS"] = "options";
    IconName["PACKAGE"] = "package";
    IconName["PAYPAL"] = "paypal";
    IconName["PEN"] = "pen";
    IconName["PENDING_BALANCE"] = "pending_balance";
    IconName["PERCENTAGE"] = "precentage";
    IconName["PHONE"] = "phone";
    IconName["PIN"] = "pin";
    IconName["PLUGIN"] = "plugin";
    IconName["PLUS"] = "plus";
    IconName["PLUS_2"] = "plus_2";
    IconName["POCKET"] = "pocket";
    IconName["POLYGON"] = "polygon";
    IconName["POUND"] = "pound";
    IconName["PRINT"] = "print";
    IconName["PRIVACY"] = "privacy";
    IconName["QUESTION_MARK"] = "question_mark";
    IconName["RECONCILIATION"] = "reconciliation";
    IconName["REFRESH"] = "refresh";
    IconName["REFUND"] = "refund";
    IconName["RELOAD_BALANCE"] = "reload_balance";
    IconName["RESEND"] = "resend";
    IconName["RESERVED_BALANCE"] = "reserved_balance";
    IconName["RESIZE"] = "resize";
    IconName["SALES"] = "sales";
    IconName["SANDBOX"] = "sandbox";
    IconName["SAVE"] = "save";
    IconName["SEARCH"] = "search";
    IconName["SELFIE"] = "selfie";
    IconName["SERVER"] = "server";
    IconName["SERVER_1"] = "server_1";
    IconName["SETTINGS"] = "settings";
    IconName["SHARE_2"] = "share_2";
    IconName["SHIELD"] = "shield";
    IconName["SHIELD_OFF"] = "shield_off";
    IconName["SHOP"] = "shop";
    IconName["SHOPPING"] = "shopping";
    IconName["SHOW"] = "show";
    IconName["SIMULATE"] = "simulate";
    IconName["SMS"] = "sms";
    IconName["SORT"] = "sort";
    IconName["SORT_2"] = "sort_2";
    IconName["SPARKELS"] = "sparkels";
    IconName["SPEED"] = "speed";
    IconName["STATUS"] = "status";
    IconName["STEPPER"] = "stepper";
    IconName["SUN"] = "sun";
    IconName["SUPPORT"] = "support";
    IconName["SUPPORT_BUBBLE"] = "support_bubble";
    IconName["TABLE"] = "table";
    IconName["TASKS"] = "tasks";
    IconName["TEXT"] = "text";
    IconName["TIMER"] = "timer";
    IconName["TOOL"] = "tool";
    IconName["TRANSACTIONS"] = "transactions";
    IconName["TRASH"] = "trash";
    IconName["UNLOCK"] = "unlock";
    IconName["UPLOAD"] = "upload";
    IconName["USER"] = "user";
    IconName["USERS"] = "users";
    IconName["USER_MINUS"] = "user_minus";
    IconName["VERIFY_IDENTITY"] = "verify_identity";
    IconName["WALLET"] = "wallet";
    IconName["WALLETS_ADDED"] = "wallets_added";
    IconName["WARNING"] = "warning";
    IconName["WARNING_2"] = "warning_2";
    IconName["WIFI_OFF"] = "wifi_off";
    IconName["WIFI_ON"] = "wifi_on";
    IconName["WORLD"] = "world";
    IconName["MAGIC_SPARKELS"] = "magic_sparkels";
    IconName["MAGIC_STICK"] = "magic_stick";
    IconName["BRUSH"] = "brush";
    IconName["SUPPORT_1"] = "support-1";
    IconName["DUPLICATE"] = "duplicate";
})(IconName || (IconName = {}));
var Icon = function (_a) {
    var className = _a.className, name = _a.name, onClick = _a.onClick, isActive = _a.isActive, themeFamily = _a.themeFamily, description = _a.description, descriptionPlacement = _a.descriptionPlacement, disabled = _a.disabled, popperConfig = _a.popperConfig, popperOptions = _a.popperOptions, htmlProps = __rest(_a, ["className", "name", "onClick", "isActive", "themeFamily", "description", "descriptionPlacement", "disabled", "popperConfig", "popperOptions"]);
    var element = (_jsx(Container, __assign({ className: "icon-" + name + " " + className, "aria-hidden": "true", "data-testid": name, onClick: disabled ? undefined : onClick, themeFamily: themeFamily, isActive: isActive, disabled: disabled }, htmlProps), void 0));
    return description ? (_jsx(Tooltip, __assign({ name: name + "-tooltip", themeFamily: themeFamily, content: description, popperConfig: __assign({ trigger: description ? 'hover' : null, placement: descriptionPlacement || 'bottom', offset: [0, 15] }, popperConfig), popperOptions: popperOptions, displayArrow: true }, { children: element }), void 0)) : (element);
};
Icon.defaultProps = {
    themeFamily: ThemeFamilies.PRIMARY,
};
export default Icon;
var Container = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: ", ";\n  line-height: 0;\n  font-family: 'fontello';\n  transition: background 0.3s ease-in;\n  border-radius: 5px;\n\n  ", "\n"], ["\n  cursor: ", ";\n  line-height: 0;\n  font-family: 'fontello';\n  transition: background 0.3s ease-in;\n  border-radius: 5px;\n\n  ",
    "\n"])), function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled;
    return (onClick && !disabled ? 'pointer' : 'inherit');
}, function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily, isActive = _a.isActive, onClick = _a.onClick, disabled = _a.disabled;
    var _b = theme.families.icon[themeFamily], main = _b.main, selectedText = _b.selectedText, disabledColor = _b.disabled;
    if (disabled) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), disabledColor);
    }
    if (isActive) {
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), selectedText);
    }
    if (onClick) {
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        &:hover {\n          background-color: ", ";\n        }\n      "], ["\n        &:hover {\n          background-color: ", ";\n        }\n      "])), main);
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
